import Button from 'devextreme-react/button';
import { useState } from 'react';
import type { TimeOffOrgOptions } from '../../../../api/timeOff';
import { countActiveCalendarFilters, summarizeCalendarFilters } from '../timeOffCalendarFilterSummary';
import type { CalendarEmployeeFilterValue } from './TimeOffCalendarEmployeeFilter';
import type { TimeOffCalendarOrgFilter } from './TimeOffCalendarOrgFilter';
import { TimeOffCalendarToolbarFilters } from './TimeOffCalendarToolbarFilters';

interface TimeOffCalendarMobileFilterBarProps {
  employeeFilter: CalendarEmployeeFilterValue | null;
  onEmployeeFilterChange: (value: CalendarEmployeeFilterValue | null) => void;
  orgFilter: TimeOffCalendarOrgFilter;
  onOrgFilterChange: (value: TimeOffCalendarOrgFilter) => void;
  orgOptions: TimeOffOrgOptions;
  orgOptionsLoading?: boolean;
  onReset: () => void;
}

export function TimeOffCalendarMobileFilterBar({
  employeeFilter,
  onEmployeeFilterChange,
  orgFilter,
  onOrgFilterChange,
  orgOptions,
  orgOptionsLoading,
  onReset
}: TimeOffCalendarMobileFilterBarProps) {
  const [expanded, setExpanded] = useState(false);
  const activeCount = countActiveCalendarFilters(employeeFilter, orgFilter);
  const summary = summarizeCalendarFilters(employeeFilter, orgFilter);

  return (
    <div className="time-off-calendar-mobile-filter-bar">
      <div className="time-off-calendar-mobile-filter-bar__row">
        <Button
          className="time-off-calendar-mobile-filter-bar__toggle"
          text={activeCount > 0 ? `Filters (${activeCount})` : 'Filters'}
          icon={expanded ? 'chevronup' : 'chevrondown'}
          stylingMode="outlined"
          type={activeCount > 0 ? 'default' : 'normal'}
          onClick={() => setExpanded((value) => !value)}
        />
        {!expanded && summary ? (
          <span className="time-off-calendar-mobile-filter-bar__summary">{summary}</span>
        ) : null}
      </div>
      {expanded ? (
        <div className="time-off-calendar-mobile-filter-bar__panel">
          <TimeOffCalendarToolbarFilters
            employeeFilter={employeeFilter}
            onEmployeeFilterChange={onEmployeeFilterChange}
            orgFilter={orgFilter}
            onOrgFilterChange={onOrgFilterChange}
            orgOptions={orgOptions}
            orgOptionsLoading={orgOptionsLoading}
            onReset={onReset}
            mobilePanel
          />
        </div>
      ) : null}
    </div>
  );
}
